module.exports = __webpack_public_path__ + "img/h.ac20711c.svg";